module.exports = __webpack_public_path__ + "static/fp-02_communication_@2x-f225c2dac4f1d01f5d3c36cc16e7dcf6.mp4";